module.exports = __webpack_public_path__ + "static/media/frames-3.97f7068a.jpg";